import React from 'react';

import Typography from 'components/typography/typography';
import { createLocale } from 'locales';

const localize = createLocale('global');

const LoadingPage: React.FC = () => {
  const tadaahLogo = `${window.STATIC_URL}assets/tadaah-logo-2024-small.svg`;
  return (
    <div className="flex flex-col gap-y-5 justify-center items-center w-screen h-screen bg-white">
      <img src={tadaahLogo} height="35px" width="128px" alt="logo" />
      <Typography as="p" variant="page-heading">
        {`${localize('loading')} ...`}
      </Typography>
    </div>
  );
};

export default LoadingPage;
